import { render } from "./councilVoting.vue?vue&type=template&id=7914e5e0&scoped=true"
import script from "./councilVoting.vue?vue&type=script&lang=js"
export * from "./councilVoting.vue?vue&type=script&lang=js"

import "./councilVoting.vue?vue&type=style&index=0&id=7914e5e0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7914e5e0"]])

export default __exports__